var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style[`cc-switcher`], _vm.$style[`cc-switcher-size-${_vm.sizeType}`]]},[_c('div',{class:[_vm.$style[`cc-switcher-btn`], _vm.$style[_vm.btnActive ? `cc-switcher-on` : `cc-switcher-off`]],on:{"click":_vm.changeValue}},[_c('span',[_vm._v(_vm._s(_vm.btnActive ? _vm.activeText : _vm.closeText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }